module.exports = __webpack_public_path__ + "static/fipcmintzebra-0442343d1b119b4087187ed468a86677.jpeg";